/* eslint-disable */

import React from "react";
import cs from "classnames";

import PageTitle from "../../atoms/PageTitle";
import Layout from "../../templates/Layout";
import { CONTACTS, PAGE_TITLES } from "../../../constants";
import classes from "./DonationRefundPolicy.module.scss";
import { LOCALES, useLocale } from "../../../hooks/useLocale/useLocale";

const DonationRefundPolicy = () => {
  const locale = useLocale(); // Get the locale from domain
  const isHeb = locale === LOCALES.HE;
  return (
    <>
      <PageTitle value={PAGE_TITLES.DONATION_REFUND_POLICY} />
      <Layout>
        {!isHeb ? (
          <>
            <div
              className={cs(classes.container, classes.wrapper, "wrapper-xl")}
            >
              <h2 className={classes.title}>Donation Refund Policy</h2>
              <p className="paragraph">
                If you have made an error in making your donation or change your
                mind about contributing to Maor.org, we will honor your request
                for a refund made within 15 days of your donation.
              </p>
              <p className="paragraph">
                To request a refund, call{" "}
                <a href={`tel:${CONTACTS.PHONE}`}>{CONTACTS.PHONE}</a>. Refunds
                are returned using the original method of payment. If you made
                your donation by credit card, your refund will be credited to
                that same credit card.
              </p>
            </div>
          </>
        ) : (
          <>
            <div
              className={cs(classes.container, classes.wrapper, "wrapper-xl")}
            >
              <h2 className={classes.title}>מדיניות החזר תרומות</h2>
              <p className="paragraph">
                אם ביצעתם טעות בעת התרומה או שיניתם את דעתכם לגבי תרומה ל"קידס
                הפקדות חינוכיות, ע"ר" אנו נכבד את בקשתכם להחזר אם תוגש בתוך 15
                יום ממועד התרומה.
              </p>
              <p className="paragraph">
                כדי לבקש החזר, התקשרו ל-
                <a href={`tel:${CONTACTS.PHONE}`}> {CONTACTS.PHONE}</a>. ההחזרים
                יבוצעו לאותו אמצעי תשלום שבו נעשתה התרומה. אם ביצעתם את התרומה
                באמצעות כרטיס אשראי, ההחזר יזוכה לאותו כרטיס אשראי.
              </p>
            </div>
          </>
        )}
      </Layout>
    </>
  );
};

export default React.memo(DonationRefundPolicy);
